<template>
    <el-form :rules="rules" label-position="top" ref="form" :model="data">
        <el-row>
            <el-col>
                <el-form-item label="组件类型" prop="impl_type">
                    <el-select filterable v-model="data.impl_type" placeholder="请选择" :disabled="dat.typeedit">
                        <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col>
                <el-form-item label="组件标识" prop="impl_defn">
                    <el-input type="textarea" v-model="data.impl_defn"></el-input>
                </el-form-item>
            </el-col>
            <el-col>
                <el-form-item label="组件名称" prop="impl_name">
                    <el-input type="textarea" v-model="data.impl_name"></el-input>
                </el-form-item>
            </el-col>
            <el-col>
                <el-form-item label="实现类" prop="impl_class">
                    <el-input type="textarea" v-model="data.impl_class"></el-input>
                </el-form-item>
            </el-col>
            <el-col>
                <el-form-item label="备注" prop="opcomment">
                    <el-input type="textarea" v-model="data.opcomment"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
    import ImplClassApi from "./ImplClass";

    export default {
        props: {
            dat: {}
        },
        data() {
            return {
                data: {
                    uuid: "",
                    impl_type: "",
                    impl_defn: "",
                    impl_name: "",
                    impl_class: "",
                    opcomment: ""
                },
                options: [
                    {
                        key: "1",
                        value: "系统组件"
                    },
                    {
                        key: "2",
                        value: "路由组件"
                    },
                    {
                        key: "3",
                        value: "对接协议"
                    }
                ],
                rules: {
                    impl_type: [
                        {required: true, message: "请选择组件类型", trigger: "blur"}
                    ],
                    impl_defn: [
                        {required: true, message: "请输入组件标识"},
                        {
                            min: 1,
                            max: 40,
                            message: "长度在 1 到 40 个字符以内",
                            trigger: "blur"
                        }
                    ],
                    impl_name: [
                        {required: true, message: "请输入组件名称"},
                        {
                            min: 1,
                            max: 150,
                            message: "长度在 1 到 150 个字符以内",
                            trigger: "blur"
                        }
                    ],
                    impl_class: [
                        {required: true, message: "请输入实现类"},
                        {
                            min: 1,
                            max: 150,
                            message: "长度在 1 到 150 个字符以内",
                            trigger: "blur"
                        }
                    ],
                    opcomment: [
                        {
                            min: 0,
                            max: 100,
                            message: "长度在 0 到 100 个字符以内",
                            trigger: "blur"
                        }
                    ]
                }
            };
        },
        // 当前组件显示到页面之后立即执行，（挂载到页面）
        mounted() {
            this.loadInfo();
        },
        watch: {
            dat: function () {
                this.loadInfo();
            }
        },
        methods: {
            loadInfo() {
                if (this.dat.uuid) {
                    this.data.uuid = this.dat.uuid;
                    this.data.impl_type = this.dat.impltype + "";
                    this.data.impl_defn = this.dat.impldefn;
                    this.data.impl_name = this.dat.implname;
                    this.data.impl_class = this.dat.implclass;
                    this.data.opcomment = this.dat.opcomment;
                }
            },
            saveImplClass() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        if (this.data.uuid === "") {
                            ImplClassApi.saveImplClass(this.data).then(() => {
                                this.$emit("upd", "");
                            });
                        } else {
                            ImplClassApi.updateImplClass(this.data).then(() => {
                                this.$emit("upd", "");
                            });
                        }
                    }
                });
            }
        }
    };
</script>

<style>
</style>
